import { render, staticRenderFns } from "./AppVersionSettings.vue?vue&type=template&id=3e2462aa&scoped=true"
import script from "./AppVersionSettings.vue?vue&type=script&lang=js"
export * from "./AppVersionSettings.vue?vue&type=script&lang=js"
import style0 from "./AppVersionSettings.vue?vue&type=style&index=0&id=3e2462aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2462aa",
  null
  
)

export default component.exports